import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { deleteTicketsPastRetention, isTicketPastRetention, TicketDatabase } from "../Utils/TicketDatabase";
import { ExtendTicket, PersonExtended, TicketExtended } from "../Utils/TypeExtensions";
import { getTicketList } from "../sharedCode/queries";

export const TICKETS_LOADING = "LOADING...";

export default function useTicketLoad(pilot: PersonExtended): string {
    const [status, setStatus] = useState(TICKETS_LOADING);
    const { error: ticketListError, data: gqlResult } = useQuery(getTicketList, {
        variables: { pilotId: pilot.id },
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache",
    });

    // NB: this code will wipe out any existing location/cost centre lookups
    async function extendAndSaveLocally() {
        const tickets = (gqlResult.getTicketsByPersonId.slice() as TicketExtended[]).filter((ticket) => !isTicketPastRetention(ticket.date));

        const listToSave = tickets.map((t) => ExtendTicket(t));
        const ticketIdsToDelete = tickets.map((t) => t.id);

        TicketDatabase.transaction("rw", TicketDatabase.ticket, async () => {
            await deleteTicketsPastRetention(TicketDatabase.ticket);
            await TicketDatabase.ticket.bulkDelete(ticketIdsToDelete).then(() => TicketDatabase.ticket.bulkAdd(listToSave));
        }) // end of transaction wrapper
            .then(() => {
                setStatus(` (${listToSave.length} TICKETS LOADED)`);
            })
            .catch((e) => {
                setStatus("CANNOT SAVE LOCALLY");
            });
    }

    useEffect(() => {
        if (ticketListError) {
            setStatus("CANNOT LOAD TICKETS");
        }
    }, [ticketListError]);

    useEffect(() => {
        if (gqlResult) {
            extendAndSaveLocally();
        }
    }, [gqlResult]);

    return status;
}
